var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14816_885)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.159839 7.45946L0.487403 7.7893C0.590493 7.89231 0.727648 7.94906 0.874234 7.94906C1.02074 7.94906 1.15806 7.89231 1.26115 7.7893L4.99776 4.05252L8.73869 7.79345C8.84162 7.89646 8.97893 7.95312 9.12544 7.95312C9.27195 7.95312 9.40934 7.89646 9.51235 7.79345L9.84 7.46564C10.0533 7.25247 10.0533 6.90523 9.84 6.69206L5.38598 2.22202C5.28305 2.11909 5.1459 2.04657 4.99809 2.04657L4.99638 2.04657C4.8498 2.04657 4.71264 2.11917 4.60971 2.22202L0.159839 6.67994C0.0567485 6.78287 0.000163168 6.92417 7.71459e-08 7.07068C6.43309e-08 7.21726 0.0567484 7.35662 0.159839 7.45946Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14816_885"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(10 10) rotate(-180)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up_arrow.e573df8a8a95e6302a7f6f150f55ef01.svg";
export { ForwardRef as ReactComponent };